export const isOrganicUser = (utmSource = ''): boolean => {
  const normalizedUtmSource = utmSource.trim()

  return (
    !normalizedUtmSource || normalizedUtmSource.toLowerCase().includes('smm')
  )
}
